export default {
  BASE_URL: process.env.REACT_APP_API_URL ?? 'http://localhost:1337/api/v1',
  REQUEST_TIMEOUT: 30000,
};
